
<main class="reference_form-main">
  <div class="main_container">
    <form [formGroup]="subsubgroupForm">
    <div class="">
      <h3 class="form_name">SubSubGroup</h3>


        <div class="input">
          <label for="">SubSubGroup</label>
          <input type="text" class="default_input reference-form" formControlName="SubSubGroupName" />
        </div>
        <div class="input">
          <label for="">SubSubGroupCode</label>
          <input type="text" class="default_input reference-form" formControlName="SubSubGroupCode" />
        </div>
        <div class="input">
            <label for="">Category</label>
            <select name="" class="default_input reference-form" formControlName="CategoryId" >
                <option *ngFor="let category of categorys" [value]="category.id">{{category.CategoryName}}</option>
            </select>
          </div>
          <div class="input">
            <label for="">SubSubGroup Type</label>
            <select name="" class="default_input reference-form" formControlName="SubSubGroupTypeId" >
                <option *ngFor="let subsubgrouptype of subsubgrouptypes" [value]="subsubgrouptype.id">{{subsubgrouptype.SubSubGroupTypeName}}</option>
            </select>
          </div>
          <div class="input">
            <label for="">SubSubGroupTypeCategory</label>
            <select name="" class="default_input reference-form" formControlName="SubSubGroupTypeCategoryId" >
                <option *ngFor="let subsubgrouptypecategory of subsubgrouptypecategorys" [value]="subsubgrouptypecategory.id">{{subsubgrouptypecategory.SubSubGroupTypeCategoryName}}</option>
            </select>
          </div>

      <div class="btn_holder">
        <button class="default_primary-button" *ngIf="selectedIndex === null" 
          (click)="addNew(subsubgroupForm.value)">Add</button>
        <button class="default_primary-button" *ngIf="selectedIndex !== null"
          (click)="addNew(subsubgroupForm.value)">Update</button>
        <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>

      </div>

    </div>
  </form>
    <div class="display_table" >
      <div class="search_container">
        <input type="text" class="default_input search"
        placeholder="Search for SubSubGroup"
        [formControl]="control"
        [appAutocomplete]="autocomplete"
        />
        <em class="ti-search"></em> 

        <app-autocomplete #autocomplete="appAutocomplete">
          <ng-template appAutocompleteContent>
            <ng-container
              *ngIf="(subgroups | filterReference: control.value) as result"
            >
              <app-option
                (click)="selectSubGroup(option.id)"
                *ngFor="let option of result"
                [value]="option.SubGroupName"
              >
                {{ option.SubGroupName }}
              </app-option>
              <app-option class="no-result" *ngIf="!result.length"
                >No result...</app-option
              >
            </ng-container>
          </ng-template>
        </app-autocomplete>
      </div>

      <div class="head" >
        <span class="item">S/N</span>
        <span class="item">SubSubGroup Name</span>
        <span class="item">SubSubGroup Code</span>
        <span class="item">Category</span>
        <span class="item">SubSubGroup Type</span>
        <span class="item">SubSubGroup Type Category</span>
        <span class="item">Action</span>

      </div>

    <div class="scroll">

    </div>
    <div class="body_content" *ngIf="status">
      <div class="the_body"
      *ngFor="let subsubgroup of subsubgroupFormArray.get('SubSubGroups')['controls']; index as i"
      (click)="onEdit(i, subsubgroup.value)" style="cursor: pointer;"
      matTooltip="Click to edit"
        aria-label="Button that displays a tooltip when focused or hovered over"
      >
        <span class="content">{{i + 1}}</span>
        <span class="content">{{subsubgroup?.value.SubSubGroupName}}</span>
        <span class="content">{{subsubgroup?.value.SubSubGroupCode}}</span>
        <span class="content">{{getCategoryName(subsubgroup?.value.CategoryId)}}</span>
        <span class="content">{{getSubSubGroupTypeName(subsubgroup?.value.SubSubGroupTypeId)}}</span>
        <span class="content">{{getSubSubGroupTypeCategoryName(subsubgroup?.value.SubSubGroupTypeCategoryId)}}</span>
        <span class="content" (click)="$event.stopImmediatePropagation()">
          <button
          class="delete_icon trash"

          (click)="deleteSubSubGroup(i, subsubgroup.value)">
          <em class="ti-trash"> </em> </button>
        </span>

      </div>
      </div>
      <div class="btn_holder">
        <button class="default_primary-button" (click)="onSubmit(subsubgroupFormArray.value)">Submit</button>
      </div>
    </div>
  </div>
</main>

<div class="box green_box"></div>
<div class="box pink_box"></div>

  
  
   